import { FileWithPreview } from 'react-dropzone';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { State } from '../../typings/state';
import { Omit, TDispatchProps, TStateProps } from '../../typings/utils';
import { CanvasAction } from '../common/actions';
import { ResourceType } from '../common/typings';
import { CreativeOptionGallerySourceType, CreativeOptionSourceType } from '../CreativeOptions/typings';
import { openGalleryPopup } from '../GalleryPane/actions';
import { GalleryPaneTypes } from '../GalleryPane/typings';
import { openModal } from '../UploadByLinkModal/actions';

import { crop, init, reset, smartCenter, uploadCancel, uploadSourceSelected } from './actions';
import { FileEditor, FileEditorProps } from './FileEditor';
import { selectFileEditorState } from './selectors';
import { FileEditorOptions, GALLERY_PANE_SOURCES } from './typings';

export interface OwnProps {
    cls?: string;
    editorId: string;
    disabled: boolean;
    sources: CreativeOptionSourceType[];

    fileIdValue: string | null;
    resourceType: ResourceType;
    groupName: string;
    name: string;

    onValueChange: (value: string) => void;
}

export type StateProps = TStateProps<FileEditorProps, Omit<OwnProps, 'fileId'>>;

export type DispatchProps = TDispatchProps<FileEditorProps, OwnProps>;

export const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
    const { editorId } = ownProps;
    const { upload, longUpload, status, preview, hasIdeaSource, hasRecentSource, fileId } = selectFileEditorState(
        state.canvasEditor.canvas.fileEditors,
        editorId
    );

    return {
        upload,
        longUpload,
        status,
        preview,
        hasIdeaSource,
        hasRecentSource,
        fileId
    };
};

const mapDispatchToProps = (dispatch: Dispatch<CanvasAction>, ownProps: OwnProps): DispatchProps => {
    const { editorId } = ownProps;

    return {
        onGallerySourceSelected: (
            resourceType: ResourceType,
            galleryType: CreativeOptionGallerySourceType,
            enabledGalleryTypes: GalleryPaneTypes[]
        ): void => {
            dispatch(openGalleryPopup(resourceType, GALLERY_PANE_SOURCES[galleryType], editorId, enabledGalleryTypes));
        },
        onUploadSourceSelected: (resourceType: ResourceType, files: FileWithPreview[]): void => {
            dispatch(uploadSourceSelected(editorId, resourceType, files));
        },
        onLinkSourceSelected: (urlType: ResourceType): void => {
            dispatch(openModal(editorId, urlType));
        },
        onReset: (): void => {
            dispatch(reset(editorId));
        },
        onUploadCancel: (): void => {
            dispatch(uploadCancel(editorId));
        },
        initFileEditor: (fileId: string | null, options: FileEditorOptions): void => {
            dispatch(init(editorId, fileId, options));
        },
        onCrop: (): void => {
            dispatch(crop(editorId));
        },
        onSmartCenter: (): void => {
            dispatch(smartCenter(editorId));
        }
    };
};

const mergeProps = (stateProps: StateProps, dispatchProps: DispatchProps, ownProps: OwnProps): FileEditorProps => {
    const { editorId, ...otherProps } = ownProps;

    return {
        ...stateProps,
        ...dispatchProps,
        ...otherProps
    };
};

export const FileEditorContainer = connect<StateProps, DispatchProps, OwnProps, FileEditorProps>(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(FileEditor);
